"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bowser_1 = __importDefault(require("bowser"));
const getDeviceType = () => {
    const parser = bowser_1.default.getParser(window.navigator.userAgent);
    const browser = parser.getBrowserName();
    const os = parser.getOSName();
    return `${browser} on ${os}`;
};
exports.default = getDeviceType;
